export default __webpack_public_path__ + "static/media/113_desktop.1fda377d.jpg";